import dosa from "../images/dosa.jpg";
import gujrati from "../images/gujrati.jpeg";
import chhola from "../images/chhola.jpg";
import idli from "../images/idli.jpg";
import masala from "../images/masala.jpg";
import paneer from "../images/paneer.jpg";
import crabMasala from "../images/Non-Veg/crabMasala.jpeg";
import FishFry from "../images/Non-Veg/Fishfry.jpg";
import GoaFishCurry from "../images/Non-Veg/GoaFishCurry.jpg";
import MuttonCurry from "../images/Non-Veg/MuttonCurry.jpg";
import porkSoupe from "../images/Non-Veg/pork Soupe.jpg";
import prawnCurry from "../images/Non-Veg/prawnCurry.jpg";
export const menu = [
  {
    name: "Dosa",
    id:1,
    description:
      "A dosa, also called dosai, is a thin pancake in South Indian cuisine made from a fermented batter of ground black lentils and rice.",
    image: dosa,
    price: 244,
  },
  {
    name: "Gujrati",
    id:2,
    description: "Gujrati Thali",
    image: gujrati,
    price: 400,
  },
  {
    name: "Chhola",
    id:3,
    description:
      "Chana masala, chole masala, or chole is a chickpea curry originating in the Indian subcontinent.",
    image: chhola,
    price: 200,
  },
  {
    name: "Idli",
    id:4,
    description:
      "dli or idly (plural: idlis) is a type of savoury rice cake, originating from South India, popular as a breakfast food in Southern India and in Sri Lanka.",
    image: idli,
    price: 149,
  },
  {
    name: "Masala Dosa",
    id:5,
    description:
      "Masala dosa are crispy rice and lentil crepes stuffed with spiced and savory potato filling.",
    image: masala,
    price: 199,
  },
  {
    name: "Panner Masala",
    id:6,
    description:
      "Dhaba Style Paneer Masala is an easy-to-make curry where paneer cubes are simmered in an onion-tomato-based spicy gravy.",
    image: paneer,
    price: 249,
  },
];
export const nonVeg = [
  {
    name: "Karimeen Pollichathu (Fish)",
    id:1,
    description:
      "Karimeen Pollichathu is a fish dish prepared out of the Pearl Spot Fish, found in the backwaters of Alleppey or Kumarakom.",
    image: FishFry,
    price: 450,
  },
  {
    name: "Fried-Ground Mutton Curry",
    id:2,
    description:
      "One of the most loved dishes in Kerala, Erachi Varutharacha is a fried ground mutton curry.",
    image: MuttonCurry,
    price: 500,
  },
  {
    name: "Kerala Style Prawn Curry",
    id:3,
    description:
      "Are you a prawn lover? Then Kerala style prawn curry is just heaven.  This traditional curry is prepared with prawns, chilli, salt and turmeric.",
    image: prawnCurry,
    price: 599,
  },
  {
    name: "Goan Fish Curry",
    id:4,
    description:
      "Goan fish curry or the Xitti Kodi is the staple diet of every Goan making it a famous food of Goa.",
    image: GoaFishCurry,
    price: 399,
  },
  {
    name: "Feijoada(pork)",
    id:5,
    description:
      "This dish is a stew of red beans and pork. Goan feijoada is a Portuguese influenced recipe.",
    image: porkSoupe,
    price: 299,
  },
  {
    name: "Crab Xacuti",
    id:6,
    description:
      "Crab Xacuti is a famous dish of Goan Food. The preparation of this dish is similar to that of Chicken Xacuti.",
    image: crabMasala,
    price: 449,
  },
];
